{
  "filtersList": [
    {
      "name": "Trier par",
      "value": "sort",
      "type": "radio",
      "groupBy": "sort",
      "excludedCategories": [],
      "options": [
        {
          "label": "En vedette",
          "checked": true,
          "value": "featured"
        },
        {
          "label": "Prix: Croissant",
          "checked": false,
          "value": "metaprice:asc"
        },
        {
          "label": "Prix: Décroissant",
          "checked": false,
          "value": "metaprice:desc"
        },
        {
          "label": "Nouveautés",
          "checked": false,
          "value": "release_date"
        },
        {
          "label": "Ordre alphabétique: A-Z",
          "checked": false,
          "value": "title:asc"
        },
        {
          "label": "Ordre alphabétique: Z-A",
          "checked": false,
          "value": "title:desc"
        }
      ]
    },
    {
      "name": "Promotions",
      "value": "cf_kw_is_product_in_offer",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "En Promotion",
          "checked": false,
          "value": "true"
        }
      ]
    },
    {
      "name": "Séries",
      "value": "cf_kw_series",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71608,
        71620,
        71640,
        71609,
        71641,
        71610
      ],
      "options": [
        {
          "label": "Série iO",
          "checked": false,
          "value": "separator_1"
        },
        {
          "label": "iO 10",
          "checked": false,
          "value": "IO10"
        },
        {
          "label": "iO 9",
          "checked": false,
          "value": "IO09"
        },
        {
          "label": "iO 8",
          "checked": false,
          "value": "IO08"
        },
        {
          "label": "iO 7",
          "checked": false,
          "value": "IO07"
        },
        {
          "label": "iO 6",
          "checked": false,
          "value": "IO06"
        },
        {
          "label": "iO 5",
          "checked": false,
          "value": "IO05"
        },
        {
          "label": "iO 4",
          "checked": false,
          "value": "IO04"
        },
        {
          "label": "iO 3",
          "checked": false,
          "value": "IO03"
        },
        {
          "label": "iO 2",
          "checked": false,
          "value": "IO02"
        },
        {
          "label": "iO Ultimate Clean",
          "checked": false,
          "value": "IO_ULT"
        },
        {
          "label": "iO Gentle Clean",
          "checked": false,
          "value": "IO_GEN"
        },
        {
          "label": "iO Radiant White",
          "checked": false,
          "value": "IO_WHI"
        },
        {
          "label": "Série Pro",
          "checked": false,
          "value": "separator_13"
        },
        {
          "label": "Pro",
          "checked": false,
          "value": "PRO"
        },
        {
          "label": "Toutes les autres brossettes de rechange",
          "checked": false,
          "value": "separator_15"
        },
        {
          "label": "Cross Action",
          "checked": false,
          "value": "OTHER_CROSS"
        },
        {
          "label": "3D White",
          "checked": false,
          "value": "OTHER_3D"
        },
        {
          "label": "Sensitive",
          "checked": false,
          "value": "OTHER_SENSITIVE"
        }
      ]
    },
    {
      "name": "Caractéristiques",
      "value": "cf_kw_characteristics",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71612,
        71622,
        71614,
        71608,
        71620,
        71640
      ],
      "options": [
        {
          "label": "Technologie",
          "checked": false,
          "value": "separator_1"
        },
        {
          "label": "Technologie Magnétique iO",
          "checked": false,
          "value": "FEAT_IO"
        },
        {
          "label": "Technologie Oscillo-Rotative",
          "checked": false,
          "value": "FEAT_OR"
        },
        {
          "label": "Solo ou Duo",
          "checked": false,
          "value": "separator_4"
        },
        {
          "label": "Solo",
          "checked": false,
          "value": "FEAT_SOLO"
        },
        {
          "label": "Duo",
          "checked": false,
          "value": "FEAT_DUO"
        },
        {
          "label": "Couleur",
          "checked": false,
          "value": "separator_7"
        },
        {
          "label": "Noir",
          "checked": false,
          "value": "FEAT_BLACK"
        },
        {
          "label": "Blanc",
          "checked": false,
          "value": "FEAT_WHITE"
        },
        {
          "label": "Rose",
          "checked": false,
          "value": "FEAT_PINK"
        },
        {
          "label": "Bleu",
          "checked": false,
          "value": "FEAT_BLUE"
        },
        {
          "label": "Violet",
          "checked": false,
          "value": "FEAT_VIOLET"
        },
        {
          "label": "Toothpaste",
          "checked": false,
          "value": "separator_13"
        },
        {
          "label": "Whitening",
          "checked": false,
          "value": "FEAT_WHITENING"
        },
        {
          "label": "Gum Care",
          "checked": false,
          "value": "FEAT_GUM_CARE"
        },
        {
          "label": "Sensitive Teeth",
          "checked": false,
          "value": "FEAT_SENSITIVE_TEETH"
        },
        {
          "label": "Repairing",
          "checked": false,
          "value": "FEAT_REPAIRING"
        },
        {
          "label": "Purifying",
          "checked": false,
          "value": "FEAT_PURIFYING"
        },
        {
          "label": "Teeth and Enamel",
          "checked": false,
          "value": "FEAT_TEETH_AN_ENAMEL"
        },
        {
          "label": "Mouthwash",
          "checked": false,
          "value": "separator_20"
        },
        {
          "label": "Gums and Enamel",
          "checked": false,
          "value": "FEAT_GUMS_AN_ENAMEL"
        },
        {
          "label": "Fresh Breath",
          "checked": false,
          "value": "FEAT_FRESH_BREATH"
        },
        {
          "label": "Protection",
          "checked": false,
          "value": "FEAT_PROTECTION"
        }
      ]
    },
    {
      "name": "Types de brossettes",
      "value": "cf_kw_material",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71605,
        71618,
        71619,
        71608,
        71620,
        71640,
        71609,
        71641,
        71610
      ],
      "options": [
        {
          "label": "Pour les gencives Sensibles",
          "checked": false,
          "value": "SENSITIVE_GUMS"
        },
        {
          "label": "Standard",
          "checked": false,
          "value": "STANDARD"
        },
        {
          "label": "Blancheur",
          "checked": false,
          "value": "WHITE"
        }
      ]
    },
    {
      "name": "Type de produit",
      "value": "cf_kw_product_type",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71605,
        71618,
        71619,
        71612,
        71622,
        71614,
        71609,
        71641,
        71610
      ],
      "options": [
        {
          "label": "Brosse à dents électrique",
          "checked": false,
          "value": "TOOTHBRUSH"
        },
        {
          "label": "Brossettes de rechange",
          "checked": false,
          "value": "BRUSH_HEADS"
        },
        {
          "label": "Dentifrice",
          "checked": false,
          "value": "TOOTHPASTE"
        }
      ]
    },
    {
      "name": "Age",
      "value": "cf_kw_ages",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71605,
        71618,
        71619,
        71612,
        71622,
        71614,
        71609,
        71641,
        71610
      ],
      "options": [
        {
          "label": "A partir de 3 ans",
          "checked": false,
          "value": "AGE_3"
        },
        {
          "label": "6 ans et plus",
          "checked": false,
          "value": "AGE_6"
        }
      ]
    },
    {
      "name": "Products for complete oral hygiene",
      "value": "cf_kw_concern",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [
        71605,
        71618,
        71619,
        71612,
        71622,
        71614,
        71608,
        71620,
        71640
      ],
      "options": [
        {
          "label": "Toothpaste",
          "checked": false,
          "value": "TOOTHPASTE"
        },
        {
          "label": "Mouthwash",
          "checked": false,
          "value": "MOUTHWASH"
        },
        {
          "label": "Dental floss",
          "checked": false,
          "value": "DENTAL_FLOSS"
        },
        {
          "label": "Irrigator",
          "checked": false,
          "value": "IRRIGATOR"
        }
      ]
    }
  ]
}